export const SSO_SETTINGS_INFO_KEY = "ssoSettingsInfo";
export const SSO_SAML_INFO_KEY = "ssoSamlInfo";
export const SSO_BACKUP_CREDENTIALS_KEY = "ssoBackupCredentials";
